var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[(_vm.header_show)?_c('my-header'):_vm._e(),_c('el-backtop',{attrs:{"target":".home-page","bottom":100}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{on:{"public_header":_vm.public_header}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }